import { z } from 'zod';
import { DataSourceTablesSchema } from './Common';

export const SilverDataSourceSchema = z
  .object({
    skip: z.boolean(),
    doNotMaterialize: z.boolean(),
  })
  .merge(DataSourceTablesSchema)
  .superRefine((data, ctx) => {
    data.modifyTables.forEach((table, index) => {
      if (table.embed && table.preserve && !table.embedColumn) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Column name is required',
          path: ['modifyTables', index, 'embedColumn'],
        });
      }

      if (table.embed && table.preserve && !table.embedColumnType) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Column type is required',
          path: ['modifyTables', index, 'embedColumnType'],
        });
      }

      table.jsonExtract.forEach((extract, extractIndex) => {
        if (extract.embed && !extract.embedColumn) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Destination column is required',
            path: [
              'modifyTables',
              index,
              'jsonExtract',
              extractIndex,
              'embedColumn',
            ],
          });
        }
      });
    });

    data.addTables.forEach((table, index) => {
      if (table.embed && table.preserve && !table.embedColumn) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Column name is required',
          path: ['addTables', index, 'embedColumn'],
        });
      }

      if (table.embed && table.preserve && !table.embedColumnType) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Column type is required',
          path: ['addTables', index, 'embedColumnType'],
        });
      }

      table.jsonExtract.forEach((extract, extractIndex) => {
        if (extract.embed && !extract.embedColumn) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Destination column is required',
            path: [
              'addTables',
              index,
              'jsonExtract',
              extractIndex,
              'embedColumn',
            ],
          });
        }
      });

      if (
        table.tableMode === 'configure' &&
        !table.fields.find((q) => q.name === 'time')
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Table must contain a field named "time"',
          path: ['addTables', index, 'fields'],
        });
      }
    });
  });

export type SilverDataSourceSchemaValues = z.infer<
  typeof SilverDataSourceSchema
>;
